import "./Loader.scss";

function Loader() {
  return (
    <div className="loader-wrapper">
      <div className="spinner"></div>
    </div>
  );
}

export default Loader;
